// extracted by mini-css-extract-plugin
export default {"container":"MarketingPage3_container__R0RQA","title":"MarketingPage3_title__o0Qw6"};